export const OUT_OF_NETWORK_STRINGS = {
    OutOfNetworkHeader: 'This doctor is out-of-network',
    FindDoctorsButton: 'Find in-network doctors',
    ContinueBookingButton: 'Continue booking',
};

export const IN_NETWORK_BOOKABLE_ONLY_STRINGS = {
    OutOfNetworkHeader: ' is out-of-network',
    OutOfNetworkMessage:
        'This provider only accepts in-network patients. We have many other providers that may be in-network or accept out-of-network clients.',
    FindDoctorsButton: 'Find other providers',
};
